import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getData, getDocOnCondition, updateDoc } from "../Firebase/firestore";
import Order_card from "./order_card";
import { statusChange } from "./orderStatus";
import { db } from "../firebase";
import ViewImages from "./viewImages";

// Import all of CoreUI's CSS
// Import all of CoreUI's JS

import { MultiSelect } from 'primereact/multiselect';

import "primereact/resources/themes/lara-light-cyan/theme.css";




import './order.css'
import close from '../assets/close.png'

import nextArr from '../assets/ARight.png'
import prevArr from '../assets/ALeft.png'


// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const orderStatus = ["Pending Confirmation", "Order Confirmed", "Order Processing", "In Transit", "Order Delivered"]

const cloths = ["suit", "kurta", "formal", "pant", "shirt", "blazer", "sadri"]

const price = ["0-1000", "1000-5000", "5000-10000", "10000+"]

// Opens a foot tracing (already straightened to A4 at 200 dpi) sized to
// exactly 210 x 297 mm, so printing at 100% gives a 1:1 outline.
function printA4(src) {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>Foot tracing</title><style>
        @page { size: A4 portrait; margin: 0; }
        html, body { margin: 0; padding: 0; }
        img { display: block; width: 210mm; height: 297mm; }
    </style></head><body><img src="${String(src).replace(/"/g, "%22")}" onload="setTimeout(function(){window.print()},300)" /></body></html>`);
    w.document.close();
}

const APPROVAL_STEPS = [
    { key: "pending", label: "Waiting for mockup" },
    { key: "mockup_sent", label: "Mockup sent" },
    { key: "changes", label: "Changes asked" },
    { key: "approved", label: "Approved, start stitching" },
];

// Uniform line: size breakup with names, each logo position, the logo files
// and the mockup-approval step (docs/uniform-plan.md §6–7 in the website repo).
// Custom-measurement people on a uniform order: the numbers the customer
// gave (AI or tape), or a form for the team to fill after the call.
const MEASURE_LABELS = {
    chest: "Chest", stomach: "Stomach", shoulder: "Shoulder", sleeve: "Sleeve", neck: "Neck",
    shirt_length: "Shirt length", kurta_short_length: "Kurta length", coat_length: "Coat length",
    vest_coat_length: "Waistcoat length", waist: "Waist", hip: "Hip", thigh: "Thigh", trouser_length: "Trouser length",
    scrub_top_length: "Scrub top length", scrub_pant_length: "Scrub pant length", tunic_length: "Tunic length",
    half_sleeve: "Half sleeve", half_sleeve_knit: "Half sleeve (knit)", bicep: "Bicep",
};
const SOURCE_LABEL = { ai: "AI estimate", ai_edited: "AI, checked by customer", manual: "Customer's tape", staff: "Taken by our team" };
const sourceLabel = (m) => `${SOURCE_LABEL[m.source] || "Received"}${m.photos ? `, ${m.photos === 2 ? "front and side photos" : "one photo"}` : ""}`;
const fieldsForPieceLabels = (pieces) => {
    const out = new Set();
    (pieces || []).forEach((label) => {
        const l = String(label).toLowerCase();
        if (/scrub pant/.test(l)) ["waist", "hip", "thigh", "scrub_pant_length"].forEach((k) => out.add(k));
        else if (/scrub/.test(l)) ["chest", "stomach", "shoulder", "scrub_top_length"].forEach((k) => out.add(k));
        else if (/tunic/.test(l)) ["chest", "stomach", "shoulder", "sleeve", "tunic_length"].forEach((k) => out.add(k));
        else if (/trouser|pant|salwar|bottom/.test(l)) ["waist", "hip", "thigh", "trouser_length"].forEach((k) => out.add(k));
        else if (/waistcoat|vest|sadri|nehru/.test(l)) ["chest", "stomach", "shoulder", "vest_coat_length"].forEach((k) => out.add(k));
        else if (/coat|blazer|jacket|sherwani|bandhgala|achkan/.test(l)) ["chest", "stomach", "shoulder", "sleeve", "coat_length"].forEach((k) => out.add(k));
        else if (/kurta|tunic|scrub/.test(l)) ["chest", "stomach", "shoulder", "sleeve", "kurta_short_length"].forEach((k) => out.add(k));
        else ["chest", "stomach", "shoulder", "sleeve", "neck", "shirt_length"].forEach((k) => out.add(k));
    });
    return Object.keys(MEASURE_LABELS).filter((k) => out.has(k));
};

function CustomPerson({ c, onSave, saving }) {
    const m = c.measurements;
    const [editing, setEditing] = useState(false);
    // The website sends the exact fields it asked for; older orders fall back to the piece names.
    const fields = m && m.values ? Object.keys(m.values) : Array.isArray(c.fields) && c.fields.length ? c.fields : fieldsForPieceLabels(c.pieces);
    const [vals, setVals] = useState(() => Object.fromEntries(fields.map((k) => [k, m && m.values ? String(m.values[k] ?? "") : ""])));
    const cell = { padding: "3px 8px", borderTop: "1px solid #eee", fontSize: "0.82rem" };
    return (
        <div style={{ border: "1px solid #e4e4e7", borderRadius: "6px", padding: "8px 10px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 12px", alignItems: "baseline" }}>
                <b>Person {c.person}{c.name ? ` · ${c.name}` : ""}</b>
                <span style={{ fontSize: "0.8rem", color: "#555" }}>{c.sizes} · custom: {(c.pieces || []).join(", ")}</span>
                <span style={{ fontSize: "0.78rem", padding: "1px 8px", borderRadius: "10px", background: m ? "#ecfdf3" : "#fff4e5", color: m ? "#166534" : "#9a5b12" }}>
                    {m ? sourceLabel(m) : "Pending · call to take"}
                </span>
                {m && (m.heightCm || m.weightKg) && <span style={{ fontSize: "0.78rem", color: "#777" }}>{m.heightCm ? `${m.heightCm} cm` : ""} {m.weightKg ? `· ${m.weightKg} kg` : ""} {m.age ? `· ${m.age} yrs` : ""}</span>}
                <button type="button" onClick={() => setEditing((v) => !v)} style={{ marginLeft: "auto", fontSize: "0.78rem", border: "1px solid #ddd", borderRadius: "4px", background: "#fff", padding: "2px 8px", cursor: "pointer" }}>
                    {editing ? "Cancel" : m ? "Edit" : "Enter measurements"}
                </button>
            </div>
            {m && !editing && (
                <table style={{ marginTop: "6px", borderCollapse: "collapse" }}>
                    <tbody>
                        {Object.entries(m.values || {}).map(([k, v]) => (
                            <tr key={k}><td style={cell}>{MEASURE_LABELS[k] || k}</td><td style={{ ...cell, fontWeight: 600 }}>{v} in</td></tr>
                        ))}
                    </tbody>
                </table>
            )}
            {editing && (
                <div style={{ marginTop: "8px", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: "6px 10px" }}>
                    {fields.map((k) => (
                        <label key={k} style={{ display: "flex", flexDirection: "column", fontSize: "0.76rem", color: "#555" }}>
                            {MEASURE_LABELS[k] || k} (in)
                            <input inputMode="decimal" value={vals[k] ?? ""} onChange={(e) => setVals({ ...vals, [k]: e.target.value })} style={{ padding: "4px 6px", border: "1px solid #ddd", borderRadius: "4px" }} />
                        </label>
                    ))}
                    <button type="button" disabled={saving || fields.some((k) => !(Number(vals[k]) > 0))}
                        onClick={() => onSave({ values: Object.fromEntries(fields.map((k) => [k, Number(vals[k])])), source: "staff", at: new Date().toISOString() }).then(() => setEditing(false))}
                        style={{ alignSelf: "end", padding: "6px 10px", border: 0, borderRadius: "4px", background: "#171717", color: "#fff", cursor: "pointer" }}>
                        {saving ? "Saving…" : "Save"}
                    </button>
                </div>
            )}
        </div>
    );
}

function UniformOrderDetails({ update, setUpdate }) {
    const u = update.uniform || {};
    const q = u.quote || {};
    const [saving, setSaving] = useState(false);
    const setApproval = async (key) => {
        setSaving(true);
        try {
            const collection = db.collection("Orders");
            const doc = (await getDocOnCondition(collection, "id", update.id))[0];
            const next = { ...update, logoApproval: key, logoApprovalAt: new Date().toISOString() };
            await updateDoc(collection, doc, next);
            setUpdate(next);
        } finally {
            setSaving(false);
        }
    };
    const saveCustom = async (person, measurements) => {
        setSaving(true);
        try {
            const collection = db.collection("Orders");
            const doc = (await getDocOnCondition(collection, "id", update.id))[0];
            const custom = (u.custom || []).map((c) => (c.person === person ? { ...c, measurements } : c));
            const pending = custom.filter((c) => !c.measurements).length;
            const next = {
                ...update,
                uniform: { ...u, custom },
                measurements: { ...(update.measurements || {}), measurementsPending: pending },
            };
            await updateDoc(collection, doc, next);
            setUpdate(next);
        } finally {
            setSaving(false);
        }
    };
    const needsApproval = !!update.logoApproval;
    return (
        <div className="order_uniform" style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            <div>
                <b>{update.qty} {Array.isArray(u.rows) && u.rows.length ? (u.mode && u.mode !== "set" ? `pieces (only ${String(u.mode).replace(/_/g, " ")})` : "full sets") : "pieces"}</b>{update.measurements.customMeasure && !(Array.isArray(u.custom) && u.custom.length) ? " · some staff want their own measurements (call them)" : ""}
                <table style={{ marginTop: "6px", borderCollapse: "collapse", width: "100%", fontSize: "0.85rem" }}>
                    <tbody>
                        {(u.sizes || []).map((s) => (
                            <tr key={s.size} style={{ borderTop: "1px solid #eee" }}>
                                <td style={{ padding: "4px 8px", fontWeight: 600 }}>{s.size} × {s.qty}</td>
                                <td style={{ padding: "4px 8px" }}>{(s.names || []).filter(Boolean).join(", ")}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {Array.isArray(u.custom) && u.custom.length > 0 && (
                    <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "6px" }}>
                        <b>Custom measurements ({u.custom.filter((c) => c.measurements).length} of {u.custom.length} in)</b>
                        {u.custom.map((c) => (
                            <CustomPerson key={c.person} c={c} saving={saving} onSave={(m) => saveCustom(c.person, m)} />
                        ))}
                    </div>
                )}
                {u.namesOn && <div style={{ fontSize: "0.82rem" }}>Names go: <b>{String((update.staffNames && update.staffNames.position) || "").replace(/_/g, " ") || "as on the product"}</b>, thread colour: <b>{u.nameColor}</b></div>}
            </div>
            <div>
                <b>Logo</b>
                {(q.logoLines || []).length === 0 ? <div>No logo</div> : (q.logoLines || []).map((l) => (
                    <div key={l.position}>{l.label}: <b>{l.method}</b>, {l.sizeIn ? `${l.sizeIn} in` : `${l.sizeCm} cm`}</div>
                ))}
                {(q.setups || []).map((x) => (
                    <div key={x.key} style={{ fontSize: "0.82rem", color: "#666" }}>Setup ({x.method}, {x.sizeIn ? `${x.sizeIn} in` : `${x.sizeCm} cm`}): {x.positions.join(" + ")}</div>
                ))}
                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "6px" }}>
                    {(u.logoFiles || []).map((f) => (
                        <a key={f.id} href={f.url} target="_blank" rel="noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", fontSize: "0.78rem" }}>
                            {/\.(png|jpe?g|webp|svg)(\?|$)/i.test(f.fileName || "") && <img src={f.url} alt={f.fileName} style={{ width: "90px", height: "90px", objectFit: "contain", border: "1px solid #ddd", background: "#fafafa" }} />}
                            {f.id === "main" ? "Main logo" : f.id}: {f.fileName}
                        </a>
                    ))}
                </div>
            </div>
            {needsApproval && (
                <div>
                    <b>Mockup approval</b>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "6px" }}>
                        {APPROVAL_STEPS.map((st) => (
                            <button
                                key={st.key}
                                type="button"
                                disabled={saving}
                                onClick={() => setApproval(st.key)}
                                style={{
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    background: update.logoApproval === st.key ? "#14213D" : "#fff",
                                    color: update.logoApproval === st.key ? "#fff" : "#222",
                                    cursor: "pointer",
                                }}
                            >
                                {st.label}
                            </button>
                        ))}
                    </div>
                    {update.logoApprovalAt && <small>Last change: {new Date(update.logoApprovalAt).toLocaleString("en-IN")}</small>}
                </div>
            )}
        </div>
    );
}

// Keeps one odd order from blanking the whole Orders page: the detail
// modal shows a message instead and the list stays usable.
class OrderModalBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidUpdate(prev) {
        if (prev.orderId !== this.props.orderId && this.state.error) this.setState({ error: null });
    }
    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: "24px", fontSize: "0.9rem" }}>
                    <b>This order's details could not be shown.</b>
                    <div style={{ marginTop: "6px", color: "#666" }}>{String(this.state.error.message || this.state.error)}</div>
                </div>
            );
        }
        return this.props.children;
    }
}

function Order_page({current}) {

    const [orders, setOrders] = useState()
    const [useOrders, setUseOrders] = useState([])
    
    const [modal ,setModal] = useState(false)

    const [orderModal, setOrderModal] = useState()
    
    const [fabircList, setFabricList] = useState([])
    const [brand, setBrandList] = useState([])

    const [update, setUpdate] = useState()
    const notesRef = useRef()
    const [loading, setLoading] = useState(false)
    
    const [imgState, setImgState] = useState(0)

    const [currH, setCurrH] = useState()

    const [State, setState] = useState(1)
    const [modalFab, setModalFab] = useState()

    const [filters, setFilters] = useState([])

    
    const [minn, setMin] = useState(false)

    const [statusFilters, setStatusFilters] = useState([])
    const [clothFilters, setClothFilters] = useState([])
    const [priceFilters, setPriceFilters] = useState([])
    const [dateFilters, setDateFilters] = useState([])
    const [fabricFilter, setFabricFilter] = useState([])
    const [brandFilter, setBrandFilter] = useState([])
    const [presets, setPresetsFilter] =useState([])

    const [searchQuery, setSearchQuery] = useState("")

    const filteredOrders = useMemo(() => {
        if (!useOrders || !useOrders.length) return useOrders || []
        const q = searchQuery.trim().toLowerCase()
        if (!q) return useOrders
        return useOrders.filter((o) => {
            const parts = [
                o.name,
                o.id,
                o.email,
                o.payment_id,
                o.des,
            ]
                .filter(Boolean)
                .map((x) => String(x).toLowerCase())
            return parts.some((p) => p.includes(q))
        })
    }, [useOrders, searchQuery])

    const hasActiveFilters =
        !!searchQuery.trim() ||
        statusFilters.length > 0 ||
        clothFilters.length > 0 ||
        priceFilters.length > 0 ||
        fabricFilter.length > 0 ||
        brandFilter.length > 0 ||
        presets.length > 0

    const clearAllFilters = useCallback(() => {
        setSearchQuery("")
        setStatusFilters([])
        setClothFilters([])
        setPriceFilters([])
        setFabricFilter([])
        setBrandFilter([])
        setPresetsFilter([])
        setMin(false)
        const fromEl = document.getElementById("from_date")
        const toEl = document.getElementById("to_date")
        if (fromEl) fromEl.value = ""
        if (toEl) toEl.value = ""
        if (orders) setUseOrders(orders)
    }, [orders])

    useEffect(() => {
        if (notesRef.current) {
            notesRef.current.value = update?.note != null ? String(update.note) : ""
        }
    }, [update])

    useEffect(()=>{
        console.log(filters)

        if(filters.length){

        } else {    
            setUseOrders(orders)
        }
    }, [filters, orders])

    const ApplyFilter=()=>{
        try{

            const fil = [
                ...clothFilters,
                ...fabricFilter,
                ...brandFilter, ]
            
            var filteredOrders = []
            orders.forEach((ord)=>{
                const jsonord = JSON.stringify(ord).toLowerCase();
                fil.forEach((e)=>{
                    if(jsonord.includes(e)){
                        filteredOrders.push(ord)
                    }

                })
            })
            if(!filteredOrders.length){
                filteredOrders = [...orders]
            }
            const from = new Date(document.getElementById("from_date").value);
            
            const to = new Date(document.getElementById("to_date").value);

            
            
            if(true || (priceFilters && priceFilters.length)){
                const P =overlappingPrice(priceFilters)
                var i= 0;
                while(filteredOrders.length > i){
                    var b = 0;
                    P.forEach((p)=>{
                        if(parseInt(filteredOrders[i].price) >= p[0] && parseInt(filteredOrders[i].price) < p[1] ){
                            console.log("considering",parseInt(filteredOrders[i].price),p[0], p[1] )
                            b=1;
                            return
                        } else {
                            console.log(parseInt(filteredOrders[i].price),p[0], p[1])
                        }
                    })
                    console.log(statusFilters, filteredOrders[i].status, orderStatus[filteredOrders[i].status.status], ( statusFilters.length && filteredOrders[i].status && !statusFilters.includes( orderStatus[ parseInt(filteredOrders[i].status.status) ] ) ))
                    if(  (b === 0 && priceFilters.length>0 ) 
                        || (( from && (new Date(filteredOrders[i].Date)) < from ) || ( to && (new Date(filteredOrders[i].Date)) > to )) 
                        || ( statusFilters.length && filteredOrders[i].status && !statusFilters.includes( orderStatus[filteredOrders[i].status.status] ) ) 
                        || ( presets.length && Object.keys(filteredOrders[i]).includes("item_type") && !presets.includes("Presets"))
                        || ( presets.length && !Object.keys(filteredOrders[i]).includes("item_type") && !presets.includes("Custom"))
                    ){
                        
                        filteredOrders.splice(i, 1)
                    } else {
                        i=i+1;
                    }
                }
            }
            
            
            setUseOrders(filteredOrders)
            
            
        } catch(e){
            console.log("from apply filter", e)
        }
    }

    useEffect(()=>{
        console.log(priceFilters)
    }, [priceFilters])

    const overlappingPrice = (priceArr)=>{
        try{
            var arr = []
            priceArr.forEach((p, key)=>{
                if(p.includes("+")){
                    arr.push([10000, 10000000])
                } else{
                    arr.push( [ parseInt(p.split("-")[0]) , parseInt(p.split("-")[1]) ] )
                }                
            })
            arr.sort((a, b) => a[0] - b[0]);
            console.log(arr)
            var i = 0;
            while(i<arr.length-1){
                if(arr[i][1] === arr[i+1][0]){
                    arr[i][1] = arr[i+1][1]
                    arr.splice(i+1, 1)
                } else {
                    i++
                }
            }
            
            console.log(arr)

            return arr


        } catch(e){
            console.log(e)
        }
    }
    
    const reloadSheet = ()=>{
        try{
            
        }catch(e){

        }
    }
    
const measure_profile = {
    "u":[ 
    {"value":"length","name":"Length"},
    {"value":"chest_around","name":"Chest"},
    {"value":"stomach","name":"Stomach"},
    {"value":"hip","name":"Hip"},
    {"value":"shoulder_width","name":"Shoulder"},
    {"value":"sleeve_length","name":"Sleev Length"},
    {"value":"neck","name":"Neck"},
    {"value":"bisep","name":"Bisep"}],
    "l":[
        {"value":"leg_length","name":"Leg Length"},
        {"value":"waist","name":"Waist"},
        {"value":"bottom","name":"Bottom"},
        {"value":"hip","name":"Hip"},
        {"value":"thigh","name":"Thighs"},
        {"value":"circle","name":"Circle"}
    ],
}

    const getFabDetails = async(Ord)=>{
        try{

            var Fabric = {}
            const collection = db.collection('Fabric').doc('Suits').collection("fabrics")

            
            if( !Object.keys(Ord).includes("item_type") ){

                const types = Object.keys(Ord.fabric)
                for(let j=0; j<types.length;j++ ){
                    const data = await getDocOnCondition(collection, "id", Ord.fabric[types[j]].fabricID);
                    Fabric[types[j]] = data[0]
                }
                
            } else {
                if(Ord.item_type === 1){
                    for(let j=0;j<Ord.fabrics.length;j++){
                        Fabric[Ord.fabrics[j].type] = {
                            brand : Ord.fabrics[j].brand,
                            brandImg : Ord.fabrics[j].brandImg,
                            color : Ord.fabrics[j].color,
                            material : Ord.fabrics[j].material,
                            pattern : Ord.fabrics[j].patter,
                            weave : Ord.fabrics[j].weave,
                            weight : Ord.fabrics[j].weight,
                            width : Ord.fabrics[j].width,
                            src: Ord.fabrics[j].src,
                            name : Ord.fabrics[j].name
                        }
                    }
                } else {
                    Fabric["Fabric"] = {
                        brand : Ord.brand,
                        brandImg : Ord.brandImg,
                        color : Ord.color,
                        material : Ord.material,
                        pattern : Ord.patter,
                        weave : Ord.weave,
                        weight : Ord.weight,
                        width : Ord.width,
                        src: Ord.src,
                        name : Ord.name
                    }
                }
                
                
            }

            // A kurta bought without its pajama keeps the pajama only for the
            // picture: it is not part of what the tailor makes.
            if (update && update.category === "only_kurta" && !update.buyPajama) delete Fabric.Pajama
            // setOrder({...order, ...{"Fab":Fabric}})
            setModalFab(Fabric)
            console.log({...update, ...{"Fab":Fabric}})
            setCurrH( Object.keys(Fabric)[0] )

        }catch(e){
            console.log(e)
        }
    }
    useEffect(()=>{
        if(update){
            getFabDetails(update).then(()=>{

            }).catch((e)=>{console.log(e)})
        }
    }, [update])


    const getOrders = async () => {
        try{
            const collection = db.collection("Orders")
            const orders = await getData(collection)
            console.log("Orders ", orders)
            return orders
        }catch(e){  
            console.log("from fetching the update", e )
        }
    }

    useEffect(()=>{
        if(current === 0){
            
            var fabrics = {}
            var brands = {}
            getOrders().then((data)=>{
                let sortedD = [...data]
                sortedD.sort((a, b) => (new Date(a.Date)) - (new Date(b.Date)) );
                sortedD.reverse();
                setOrders(sortedD)
                data.forEach((e)=>{

                    if( !Object.keys(e).includes("item_type") ){
                        e.types.forEach((ele)=>{
                            if(!Object.keys(fabrics).includes(e.fabric[ele]["fabric"] )){
                                fabrics[e.fabric[ele]["fabric"]] = 1
                            }
                            if(!Object.keys(brands).includes(e.fabric[ele]["brand"] )){
                                brands[e.fabric[ele]["brand"]] = 1
                            }
                        })
                    } else {
                        e.fabrics.forEach((ele)=>{
                            if(!Object.keys(fabrics).includes(ele["name"] )){
                                fabrics[ele.name] = 1
                            }
                            if(!Object.keys(brands).includes(ele.brand )){
                                brands[ele.brand] = 1
                            }
                        })
                    }

                setFabricList(Object.keys(fabrics))
                setBrandList(Object.keys(brands))
                
                })
            }).catch((e)=>{console.log("from orders. ", e)})
            
        }
    }, [current])
    return ( 
    <div className="button_upload_page button-upload-premium-page upload-product-page view-product-page--fixed-filter view-product-page-v2 orders-page-with-fixed-filter">
        {loading && (
            <div className='f-loading'>
                <div 
                    style={{"position":"fixed", "background":"rgb(0, 0, 0, 0.5)", "width":"100%", "height":"100%", "left":"0", "top":"0"}}
                ></div>
                <img alt="" src="https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.svg" onError={(e) => { e.currentTarget.src = 'https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'; }} />
            </div>
        )}

        <div className="upload-product-center view-product-center-wide Orders orders-page-premium">
            <div className="view-product-filter-shell">
                <div className="view-product-filter-bar" role="search">
                    <button
                        type="button"
                        className={`orders-filter-bar-toggle ${minn ? "is-open" : ""}`}
                        onClick={() => { setMin((curr) => !curr); }}
                    >
                        <span className="orders-filter-bar-toggle-label">Advanced filters</span>
                        <span className="orders-filter-bar-toggle-chevron" aria-hidden="true">{"\u25be"}</span>
                    </button>
                    <button type="button" className="orders-filter-apply orders-filter-apply--bar" onClick={() => { ApplyFilter(); }}>
                        Apply
                    </button>
                    <div className="view-product-filter-search view-product-filter-search--premium">
                        <input
                            id="orders-search"
                            type="search"
                            className="view-product-filter-search-input"
                            placeholder="Search order #, name, email, payment…"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            autoComplete="off"
                        />
                        <span className="view-product-filter-search-icon" aria-hidden="true">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="2" />
                                <path d="M16.5 16.5 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </span>
                    </div>
                </div>

                {minn ? (
                    <div className="orders-advanced-drawer">
                        <div className="orders-filter-row">
                            <div className="filter_item">
                                Order status
                                <div>
                                    <MultiSelect value={statusFilters} onChange={(e) => { setStatusFilters(e.value); }} options={orderStatus} display="chip"
                                        placeholder="Status" maxSelectedLabels={1} className="w-full" />
                                </div>
                            </div>
                            <div className="filter_item">
                                Cloth
                                <div>
                                    <MultiSelect value={clothFilters} onChange={(e) => { setClothFilters(e.value); }} options={cloths} display="chip"
                                        placeholder="Cloths" maxSelectedLabels={1} className="w-full" />
                                </div>
                            </div>
                            <div className="filter_item">
                                Order type
                                <div>
                                    <MultiSelect value={presets} onChange={(e) => { setPresetsFilter(e.value); }} options={["Presets", "Custom"]} display="chip"
                                        placeholder="Type" maxSelectedLabels={1} className="w-full" />
                                </div>
                            </div>
                        </div>
                        <div className="orders-filter-row">
                            <div className="filter_item">
                                Price
                                <div>
                                    <MultiSelect value={priceFilters} onChange={(e) => { setPriceFilters(e.value); }} options={price} display="chip"
                                        placeholder="Price" maxSelectedLabels={1} className="w-full" />
                                </div>
                            </div>
                            {fabircList && fabircList.length > 0 ? (
                                <div className="filter_item">
                                    Fabrics
                                    <div>
                                        <MultiSelect value={fabricFilter} onChange={(e) => { setFabricFilter(e.value); }} options={fabircList} display="chip"
                                            placeholder="Fabrics" maxSelectedLabels={1} className="w-full" />
                                    </div>
                                </div>
                            ) : null}
                            {brand && brand.length > 0 ? (
                                <div className="filter_item">
                                    Brands
                                    <div>
                                        <MultiSelect value={brandFilter} onChange={(e) => { setBrandFilter(e.value); }} options={brand} display="chip"
                                            placeholder="Brands" maxSelectedLabels={1} className="w-full" />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="orders-filter-row orders-filter-row--dates">
                            <label className="orders-date-field">
                                <span>From</span>
                                <input type="date" id="from_date" className="orders-date-input" />
                            </label>
                            <label className="orders-date-field">
                                <span>To</span>
                                <input type="date" id="to_date" className="orders-date-input" />
                            </label>
                        </div>
                    </div>
                ) : null}

                <div className="view-product-filter-meta-row">
                    <p className="view-product-filter-meta">
                        <span className="view-product-filter-count-pill">{filteredOrders.length}</span>
                        <span className="view-product-filter-meta-text">
                            shown
                            {searchQuery.trim() ? " · search active" : ""}
                            {` · ${useOrders?.length ?? 0} after advanced filters`}
                            {orders ? ` · ${orders.length} in catalog` : ""}
                        </span>
                    </p>
                    {hasActiveFilters ? (
                        <button type="button" className="view-product-clear-filters" onClick={clearAllFilters}>
                            Clear all
                        </button>
                    ) : null}
                </div>
            </div>

            <div
                className="view-product-fixed-filter-spacer orders-filter-spacer"
                style={{ height: minn ? 118 + 220 : undefined }}
                aria-hidden="true"
            />

            <div className="orders-page-list">
                {filteredOrders && filteredOrders.map((val) => (
                    <Order_card
                        key={val.id ?? val.doc ?? String(val.Date)}
                        order={val}
                        setOrder={setOrders}
                        setModal={setModal}
                        setOrderModal={setOrderModal}
                        setUpdate={setUpdate}
                    />
                ))}
            </div>
        </div>
        <div className="modal fade orders-update-modal-root" id="exampleModalCenter" tabIndex={-1} role="dialog" aria-labelledby="ordersUpdateModalTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered orders-update-modal-dialog" role="document">
                <div className="modal-content orders-update-modal-content">
                    <div className="modal-header orders-update-modal-header">
                        <div className="orders-update-modal-head-text">
                            <p className="orders-update-modal-kicker">Order workflow</p>
                            <h5 className="modal-title orders-update-modal-title" id="ordersUpdateModalTitle">
                                Update order
                            </h5>
                        </div>
                        <button type="button" className="orders-update-modal-close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body orders-update-modal-body">
                        <div className="orders-update-field">
                            <span className="orders-update-label">Order ID</span>
                            <p className="orders-update-order-id">{update ? String(update.id) : "—"}</p>
                        </div>
                        <div className="orders-update-field">
                            <label className="orders-update-label" htmlFor="status_type">
                                Status
                            </label>
                            <select
                                key={update?.id ?? "order-status"}
                                name="status_type"
                                id="status_type"
                                className="orders-update-select"
                                defaultValue={
                                    update && update.status != null
                                        ? Number(typeof update.status === "object" ? update.status.status : update.status)
                                        : 0
                                }
                            >
                                {update &&
                                    orderStatus.map((label, key) => (
                                        <option key={key} value={key}>
                                            {label}
                                        </option>
                                    ))}
                            </select>
                        </div>
                        <div className="orders-update-field orders-update-field--note">
                            <label className="orders-update-label" htmlFor="order-update-notes">
                                Internal note
                            </label>
                            <textarea
                                id="order-update-notes"
                                className="orders-update-notes"
                                ref={notesRef}
                                placeholder="Optional — visible in your records for this update…"
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="modal-footer orders-update-modal-footer">
                        <button
                            type="button"
                            className="orders-update-save"
                            data-dismiss="modal"
                            onClick={async () => {
                                if (update) {
                                    setLoading(true)
                                    const sel = Number(document.getElementById("status_type").value)
                                    const collection = db.collection("Orders")
                                    const doc = (await getDocOnCondition(collection, "id", update.id))[0]
                                    await updateDoc(collection, doc, {
                                        ...update,
                                        ...statusChange(update, sel),
                                        note: notesRef.current ? notesRef.current.value : "",
                                    })
                                    setLoading(false)
                                    window.location.reload()
                                }
                            }}
                        >
                            Save changes
                        </button>
                    </div>
                </div>
            </div>
        </div>

            {/* {orderModal === 1 && <div>
        <div className="oder_opac"></div>
        <div className="order_modal both_center">
            <img src={close} className="o-m-close"
                type="button" onClick={()=>{
                    setOrderModal(0)
                }}
            />
            <div className="order_modal_img">

                {update && <ViewImages
                    sel = {update}
                    loading = {loading}
                    setLoading={setLoading}
                    imgState={imgState}
                    setImgState={setImgState}
                    type = {1}
                />}

                        
            </div>
            <div className="order_modal_des">
                <h3>{update.name}</h3>
                <h4>Order ID : {update.id}</h4>
                <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
                <br/><h5 className="txt-font1">Total : {update.price}</h5>
                <h5 >Status : {update.status ? `${orderStatus[update.status]}` :`${orderStatus[0]}` }</h5>
                <br/>
                <h5>User Details</h5>
                <div>Email : {update.email}</div>
                <br/><div><b>Address : </b></div>
                <div> Delivered Adddress</div>
                <div>Raghavendra <br/> Ashok Nagar,8977664489 <br/>Karnataka 510043</div>
                <br/><div><b>Payment ID : {update.payment_id} </b></div>
               

            </div>
        </div>
        </div>} */}

        {/* //////////////////////////////// */}

        {orderModal === 1 && <>
        <div className="oder_opac"></div>
        <OrderModalBoundary orderId={update && update.id}>
        <div className="order_modal both_center">
            <img src={close} className="o-m-close"
                type="button" onClick={()=>{
                    setOrderModal(0)
                }}
            />
            <div className="order_modal_img">

            {!Object.keys(update).includes("item_type") && <><img src={nextArr} className='v-arr-l'
                            onClick={()=>{
                                if(imgState > 0){
                                    // console.log("Clicking")
                                    setLoading(true)
                                }
                                setImgState((curr)=>(
                                curr > 0 ? curr - 1 : 0
                            ))}}
                        />
                    <img src={prevArr} className='v-arr-r'
                            onClick={()=>{
                                if(imgState < State-1){
                                    // console.log("clicking")
                                    setLoading(true)
                                    setImgState((curr)=>(
                                        curr < State ? curr + 1 : curr
                                    ))
                                }
                                
                                
                        }}
                            
                        />
                        </>
                }
                {update && 
                <>
                {!Object.keys(update).includes("item_type") ? 
                    <ViewImages
                    sel = {update}
                    loading = {loading}
                    setLoading={setLoading}
                    imgState={imgState}
                    setState1 = {setState}
                    setImgState={setImgState}
                    type = {1}
                />
                
                : <img src={update.src} style={{"width":"80%", "height":"100%", "objectFit":"cover"}}/>
                }
                </>
                }

                        
            </div>
            <div className="order_modal_wrapper">
            <div className="order_modal_des">
                <div className="txt-font">{update.name}</div>
                <div>Order ID : {update.id}</div>
                <div>Item Includes :  { modalFab && Object.keys(modalFab).map((val1)=>{return(<span>{val1},</span>)})   } </div>
                {/* <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
                <br/>
                <div className="txt-font1">Total : 
                { Object.keys(update).includes("item_type") && update.item_type === 0 ? 
                <>
                    {Number(250).toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                        })}</>
                    :
                
                    // What the customer agreed to pay for this item (bill.total,
                    // after the cart offers) when the order carries it; the list
                    // price is shown beside it. Older orders only have price.
                    <>{Number((update.bill && update.bill.listPrice != null ? update.bill.total : update.price) || 0).toLocaleString('en-IN', {
                    maximumFractionDigits: 2,
                    style: 'currency',
                    currency: 'INR'
                    })}
                    {update.bill && update.bill.listPrice != null && Number(update.bill.listPrice) !== Number(update.bill.total) && (
                        <span style={{ marginLeft: 8, textDecoration: 'line-through', opacity: 0.55 }}>
                            {Number(update.bill.listPrice).toLocaleString('en-IN', { maximumFractionDigits: 0, style: 'currency', currency: 'INR' })}
                        </span>
                    )}
                    {update.amountCaptured != null && (
                        <div style={{ fontSize: '0.85em', opacity: 0.75 }}>
                            Paid on Razorpay (whole order): {Number(update.amountCaptured).toLocaleString('en-IN', { maximumFractionDigits: 0, style: 'currency', currency: 'INR' })}
                        </div>
                    )}
                    </>
                    }
                    {/* { Number(update.price).toLocaleString('en-IN', {
                        maximumFractionDigits: 2,
                        style: 'currency',
                        currency: 'INR'
                    }) } */}
                </div>
                <div className="txt-font1">Status : {orderStatus[Number(update.status && typeof update.status === "object" ? update.status.status : update.status) || 0] || "Pending Confirmation"}</div>
                <br/><br/>
                {(() => {
                    // Billing used to repeat the delivery address; it is stored on
                    // the order as billingAddress (or addresses.billing). A business
                    // order (a shop buying to resell) carries company + GSTIN there.
                    const delivery = update.Address || (update.addresses || {}).delivery || {};
                    const billing = update.billingAddress || (update.addresses || {}).billing || delivery;
                    const pickup = update.pickupAddress || (update.addresses || {}).pickup || null;
                    const isClone = (update.measurements || {}).type === 3;
                    const lines = (a) => (
                        <>
                            <div>{a.name}{a.last_name ? ` ${a.last_name}` : ''}</div>
                            <div>{a.phone}</div>
                            <div>{a.address}</div>
                            <div>{a.city}</div>
                            <div>{a.state} | <div>{a.pincode}</div></div>
                        </>
                    );
                    return (
                        <div className="order_Address">
                            <div className="o-d-add">
                                <b>Delivery Address</b>
                                {lines(delivery)}
                            </div>
                            <div className="o-b-add">
                                <b>Billing Address</b>
                                {billing.gstin && (
                                    <div className="o-gst">
                                        <div><b>{billing.company}</b></div>
                                        <div>GSTIN: <b>{billing.gstin}</b></div>
                                    </div>
                                )}
                                {lines(billing)}
                            </div>
                            {isClone && pickup && (
                                <div className="o-b-add">
                                    <b>Pickup Address (garment to clone)</b>
                                    {lines(pickup)}
                                </div>
                            )}
                        </div>
                    );
                })()}
                <br/>
                <div className="txt-font">Fabric Details</div>
                <div>
                    {update && modalFab && 
                    <div className='preset_fabric_details'>
                        <div className='p_f_d_t txt-font1'
                            style={{width:"100%"}}
                        >
                            {Object.keys(modalFab).map((val1)=>{return(<div className={ currH === val1 ? "h_p_h p_h_i" : "p_h_i" } 
                                style={{width:`${100/Object.keys(modalFab).length}%`}}
                                onClick={()=>{
                                    setCurrH(val1)
                                }}
                                type="button"
                            >{val1}</div>)})}
                        </div>
    
                        <div style={{display:"flex"}}>
                            <div style={{"width":"45%", marginRight:"5%"}}><img src={(modalFab[currH] || {})["src"]} className='p_f_d_img'/></div>
                            <div style={{"width":"50%", display:"flex", flexDirection:"column"}}>
                                <b><span>{(modalFab[currH] || {}).name}</span></b>
                                <span> <img src={(modalFab[currH] || {}).brandImg} style={{"width":"80px"}}/> {(modalFab[currH] || {}).brand}</span>
                                <span>{(modalFab[currH] || {}).material}</span>
                                <span>Weave : {(modalFab[currH] || {}).weave}</span>
                                <span>Weight : {(modalFab[currH] || {}).weight} | Width : {(modalFab[currH] || {}).width}</span>
                            </div>
                        </div>
                    </div>
                    }
                </div>

                
                <div>
                <div className="txt-font1"
                    style={{textAlign:"center", backgroundColor:"#14213D", color:"white", borderRadius:"5px"}}
                > 
                    {(update.measurements || {}).type === 0
                        ? "Measurement - Size Chart"
                        : (update.measurements || {}).type === "uniform"
                            ? "Uniform: sizes, logo and names"
                            : (update.measurements || {}).type === "head"
                            ? "Head Size"
                            : (update.measurements || {}).type === "foot"
                                ? "Foot Tracing (mojari)"
                                : (update.measurements || {}).type === "none"
                                    ? "No measurement needed"
                                    : "Custom Measurement"}</div>

                <br/>

                {(update.measurements || {}).type === "uniform" ? (
                    <UniformOrderDetails update={update} setUpdate={setUpdate} />
                ) : (update.measurements || {}).type === "head" ? (
                    <div className="order_accessory_size">
                        <label>Head circumference: <b>{(update.measurements || {}).cm} cm</b> (size <b>{(update.measurements || {}).size}</b>)</label>
                    </div>
                ) : (update.measurements || {}).type === "foot" ? (
                    <div className="order_accessory_size" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {(update.measurements || {}).shoeSize && <label>Usual shoe size: <b>{(update.measurements || {}).shoeSize}</b></label>}
                        {["right", "left"].filter((k) => update.measurements[k]).map((k) => (
                            <div key={k} style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                                <img src={update.measurements[k].trace} alt={`${k} foot tracing`} style={{ width: "120px", border: "1px solid #ddd" }} />
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                    <b style={{ textTransform: "capitalize" }}>{k} foot</b>
                                    <button type="button" onClick={() => printA4(update.measurements[k].trace)}>Print at 100% (A4)</button>
                                    <a href={update.measurements[k].photo} target="_blank" rel="noreferrer">Original photo</a>
                                </div>
                            </div>
                        ))}
                        <small>Print on A4 with scale 100% / "Actual size" (not "Fit to page"). The paper outline in the print should sit on the sheet's edges.</small>
                    </div>
                ) : (update.measurements || {}).type === "none" ? null : (update.measurements || {}).type === 1 ? 
                <div style={{
                    width:"100%",
                    display:"flex",
                    gap:"10px"
                }} >
                    <div className="order_m_m_l"
                        style={{width:"50%",
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >
                        <b>Upper Body</b>
                        {measure_profile.u.map((val)=>{
                            return(<label>{val["name"]} : <b>{((update.measurements || {}).upper_body || {})[val["value"]]}</b> IN </label>)
                        })}
                        
                    </div>
                    <div className="order_m_m_r"
                        style={{width:"50%",
                            display:"flex",
                            flexDirection:"column"
                        }}
                    >   
                        <b>Lower Body</b>
                        {measure_profile.l.map((val)=>{
                            return(<label>{val["name"]} : <b>{((update.measurements || {}).lower_body || {})[val["value"]]}</b> IN </label>)
                        })}
                    </div>
                </div>
                : <div>

                    <label> <b> Upper Body : </b> {typeof (update.measurements || {}).upper_body === "object" ? "see profile" : (update.measurements || {}).upper_body} IN </label><br/>
                    <label> <b>Lower Body : </b> {typeof (update.measurements || {}).lower_body === "object" ? "see profile" : (update.measurements || {}).lower_body} IN </label><br/>
                    
                </div>

                }

                </div>
                
                
            </div>
            </div>
        </div>
        </OrderModalBoundary>
        </>}

        {/* //////////////////// */}
    </div> );
}

export default Order_page;